class TaskListController {
  constructor(Task) {
    this.Task = Task;

  }

  $onInit() {
    this.taskTypes = [
      { value: 'available_or_accepted_by_engineer', label: 'All tasks', selected: true },
      { value: 'available', label: 'New'},
      { value: 'opened', label: 'Open'},
      { value: 'closed', label: 'Closed'},
    ];
  }

  loadMore() {
    this.page += 1;
    this.loadTasks({filter: this.selectedFilter, page: this.page});
  }

  loadTasks(params = {}) {
    const oldTasks = this.tasks;
    this.loading = true;
    this.Task.query(params).$promise
      .then((response) => {
        this.meta = response.meta;
        this.lastResponse = response.tasks;
        this.tasks.push(...response.tasks);
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.tasks = oldTasks;
      });
  }

  onTypeSelect(option) {
    this.page = 1;
    this.tasks = [];
    this.selectedFilter = option.value;
    this.loadTasks({filter: this.selectedFilter, page: this.page});
  }
}

TaskListController.$inject = ['Task'];
export default TaskListController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/tasks/screens/task-list/task-list.controller.js